import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      enabled: true, // Auto-run query on mount
      retry: 0, // Retry failed requests 3 times
      staleTime: 0, // How long data is considered "fresh" (ms)
      cacheTime: 5 * 60 * 1000, // Time inactive cache stays before garbage collection (5 mins)
    },
    mutations: {
      retry: 0,
    },
  },
});
